import { sendAnalytics } from 'shared/utils/analytics';

export const trackBannerClick = () => sendAnalytics({ action: 'Click', label: 'add_myhome' });
